<div class="p-g pie-container">
  <h3 class="p-g-12 uppercase m-0 mt-2 admin-dash-stats-label">{{headerStr}}</h3>
  <div class="p-g-12">
    <p-chart type="pie" [data]="buildData"></p-chart>
  </div>
</div>
